import * as types from "./actionTypes";

const initialState = {
  message: null,
  isError: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.ERROR_SET:
      return {
        ...state,
        message: action.payload,
        isError: true,
      };
    case types.ERROR_RESET:
      return initialState;

    default:
      return state;
  }
};
